<template>
  <v-dialog persistent v-model="show" width="800" height="500">
    <v-card class="popup-fijo">
      <v-btn icon class="btn-cancelar-flotante" @click="cancelar">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <v-card-title>
        <div class="headline">Modificar Fichaje</div>
      </v-card-title>

      <hr class="header-separator" />

      <v-card-text class="popup-contenido">
        <v-expand-transition>
          <div v-show="!editandoFecha">
            <v-container>
              <v-row dense>
                <v-col cols="12">
                  <div class="campo-label">Justificación</div>
                  <v-text-field
                    v-model="form.justification"
                    placeholder="Escriba el motivo de su modificación"
                    class="campo-redondeado"
                    hide-details
                    solo
                    required
                  ></v-text-field>
                  <div v-if="errors.justification" class="error-text">{{ errors.justification }}</div>
                </v-col>

                <v-col cols="4">
                  <div class="campo-label">Tipo</div>
                  <v-select
                    v-model="form.type"
                    :items="[
                      { value: 'in', text: 'Entrada' },
                      { value: 'out', text: 'Salida' },
                      { value: 'pause', text: 'Pausa' },
                      { value: 'continue', text: 'Continuar' }
                    ]"
                    label="Tipo"
                    class="campo-redondeado"
                    hide-details
                    solo
                    required
                  ></v-select>
                </v-col>

                <v-col cols="8">
                  <div class="campo-label">Fecha y hora</div>
                  <v-text-field
                    v-model="form.dataText"
                    readonly
                    class="campo-redondeado"
                    hide-details
                    solo
                    @click="editandoFecha = true"
                  />
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-expand-transition>

        <v-expand-transition>
          <div v-show="editandoFecha" class="modo-edicion-fecha">
            <div class="rectangulo-edicion">
              <div class="fecha-hora-body">
                <v-time-picker
                  v-model="form.timePart"
                  format="24hr"
                  full-width
                  class="selector-hora"
                />
                <v-date-picker
                  v-model="form.datePart"
                  no-title
                  class="selector-calendario"
                  locale="es"
                />
              </div>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="btn-fondo1" @click="cerrarEdicionFecha">Aceptar fecha</v-btn>
                <v-btn class="btn-fondo1" @click="cancelar">Cancelar</v-btn>
              </v-card-actions>
              <hr class="header-separator" />
            </div>
          </div>
        </v-expand-transition>
      </v-card-text>
      <v-card-actions class="justify-center" v-if="!editandoFecha">
        <v-btn class="btn-fondo" @click="acceptar">{{ isAdmin ? 'Guardar' : 'Sugerir cambio' }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { Clock } from "@/modules/working_hours/domain/Clock";
import {
  formatDateTimeToString,
  formatDateToString,
  formatTimeToString,
  combineDateAndTime
} from "@/modules/working_hours/domain/Utils";

export default {
  name: 'UpdateClockPopup',
  props: {
      show: {
          type: Boolean,
          required: true
      },
      clock: {
          type: Object,
          required: false
      },
      errors: {
          type: Object,
          required: false
      },
      isAdmin: {
          type: Boolean,
          default: false
      }
    },
  data() {
    return {
      menu: false,
      justificanteDialog: false,
      editandoFecha: false,
      form:{
        justification:'',
        type:'',
        timestamp:null,
        justificante: ''
      }
    };
  },
  mounted () {
    this.form.type = this.clock.type;
    const date = this.clock.timestamp;

    // Usar funciones de Utils para formatear la fecha
    this.form.timePart = formatTimeToString(date);
    this.form.dataText = formatDateTimeToString(date);
    this.form.originalDate = formatDateToString(date);
  },
  methods: {
    assignarDataHora() {
      this.form.dataText = `${this.form.datePart} ${this.form.timePart}`;
    },
    cerrarEdicionFecha() {
      const fechaAUsar = this.form.datePart || this.form.originalDate;
      this.form.dataText = `${fechaAUsar} ${this.form.timePart}`;
      this.editandoFecha = false;
    },
    acceptar() {
      const fechaAUsar = this.form.datePart || this.form.originalDate;
      const combinedDateTime = combineDateAndTime(fechaAUsar, this.form.timePart);

      let updated_clock = new Clock(
        this.clock.uuid,
        combinedDateTime,
        this.form.type,
        this.clock.user,
        this.changes,
        false
      );
      let justification = this.form.justification;
      this.$emit('close', {updated_clock, justification});
    },
    cancelar() {
      this.$emit('close');
    },
  },
};
</script>

<style>

.headline {
  width: 419px;
  color: var(--Primary-800, var(--v-primary-base));
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.btn-fondo {
  border-radius: 8px!important;
  background: var(--Primary-700, #7339B7)!important;
  padding: 6px 16px!important;
  min-width: 120px!important;
  color: var(--Neutral-50, var(--v-neutral-base))!important;
  text-align: center!important;
  font-family: Roboto!important;
  font-size: 14px!important;
  font-style: normal!important;
  font-weight: 500!important;
  line-height: normal!important;
}

.btn-fondo1 {
  background-color: #FFFFFF !important; 
  color: #7339B7 !important;         
  padding: 6px 6px !important;
  min-width: 120px !important;
  text-align: center !important;
  font-family: Roboto !important;
  font-size: 12px !important;
  font-style: normal !important;
  font-weight: 500 !important;
  line-height: normal !important;
}

.btn-cancelar-flotante {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
  color: #7339B7;
}

.header-separator {
  margin-top: 16px;
  border: none;
  border-top: 1px solid #ccc;
}

.marco-justificacion {
  border-radius: 8px;
  border: 1px solid var(--Neutral-200, #D1D1D1);
  background: var(--White, #FFF);
  padding: 4px 8px;
}

.campo-redondeado .v-input__control {
  border: 1px solid #D1D1D1;
  border-radius: 12px;
  background-color: white;
}

.campo-redondeado .v-input__control::before,
.campo-redondeado .v-input__control::after {
  border-bottom: none !important;
  height: 0 !important;
  box-shadow: none !important;
}

.campo-redondeado .v-input__slot {
  border-bottom: none !important;
  box-shadow: none !important;
}

.campo-label {
  color: #565656;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.fecha-hora-picker {
  padding: 8px;
}

.fecha-hora-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 8px 8px;
}

.modo-edicion-fecha {
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.rectangulo-edicion {
  width: 800px;
  height: 420px;
  box-sizing: border-box;
  padding: 16px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.fecha-hora-body {
  display: flex;
  gap: 12px;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
  flex: 1;
  overflow: hidden;
}

.v-card-actions {
  padding: 8px 0 !important;
  justify-content: center;
}

.selector-hora {
  width: 300px;
  height: auto;
  border-radius: 50%;
  background: var(--Neutral-150, #E7E7E7);
  display: flex;
  justify-content: center;
  align-items: center;
}

.selector-calendario {
  flex: 1;
  max-width: 770px;
}

.v-time-picker-title {
  background-color: transparent !important;
  box-shadow: none !important;
}

.selector-hora .v-time-picker-clock {
  width: 256px;
  height: 256px;
  transform: scale(0.8);
  border-radius: 50%;
  background: var(--Neutral-150, #E7E7E7);
}

.selector-hora .v-time-picker-title__time {
  font-size: 12px !important;
  transform: scale(0.7) !important;
  padding: 2px 6px !important;
  border-radius: 6px !important;
  gap: 2px !important;
  margin-bottom: -30px !important;
  border: 1px solid #ccc !important;
  background-color: #9F6BE1 !important;
}

.dialog-ajustado {
  min-height: 500px;
}

.selector-hora .v-time-picker-clock__hand,
.selector-hora .v-time-picker-clock__center,
.selector-hora .v-time-picker-clock__item--active {
  background-color: #9F6BE1 !important;
}

.selector-calendario .v-date-picker-table .v-btn.v-btn--active,
.selector-calendario .v-date-picker-table .v-btn.v-btn--current,
.selector-calendario .v-date-picker-table .v-btn.v-btn--current.v-btn--active {
  background-color: #9F6BE1 !important;
  color: #FFFFFF !important;
  border: 1px solid #9F6BE1 !important;
}

.selector-calendario .v-date-picker-table .v-btn:hover:not(.v-btn--current):not(.v-btn--active) {
  background-color: rgba(159,107,225,0.1) !important;
}

.selector-hora .v-picker__title,
.selector-hora .v-time-picker-title {
  background: transparent !important;
  box-shadow: none !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.selector-hora .v-picker__title__btn,
.selector-hora .v-picker__title__btn.v-picker__title__btn--active,
.selector-hora .v-picker__title__btn:hover,
.selector-hora .v-picker__title__btn:focus {
  background: transparent !important;
  box-shadow: none !important;
}

.popup-fijo {
  width: 800px !important;
  height: 500px !important;
  max-width: none !important;
  max-height: none !important;
}

.v-card__text,
.v-container,
.v-card__actions {
  padding: 0 !important;
}

.v-row {
  margin: 0 !important;
}

.v-col {
  padding: 0px !important;
}

.popup-contenido {
  min-height: auto !important;
  max-height: none !important;
  overflow: hidden !important;
}

.error-text {
  color: red;
  font-size: 12px;
  margin-top: 4px;
}

</style>